import { useDispatch, useSelector } from "react-redux";
import { ThemeContext } from "styled-components";
import React, { useContext, useMemo } from "react";

import { changeStep } from "store/modules";
import { Step, StepContentWrapper } from "components";
import { withWizard } from "containers";

import Responsible from "./responsible";
import ContactInfo from "./contactInfo";
import Address from "./address";
import TabContainer from "components/tabContainer";
import { AUTH_TYPES } from "constants/authTypesName";

export default function BasicInfoWizard({
  initialStep,
  currentStep: parentCurrentStep,
  navigateForward: parentNavigateForward,
  enable,
  reset,
  cancel,
}) {
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const { basicInfo } = useSelector((state) => state.subscription);
  const { responsible, address, contactInfo } = basicInfo || {};

  const documentFromStorage = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem(AUTH_TYPES.STORAGE_AUTH_CNPJ_PARAM_NAME)) || '';
    } catch {
      return '';
    }
  }, []);

  const sellerIdFromStorage = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem(AUTH_TYPES.STORAGE_SELLER_ID_PARAM_NAME)) || '';
    } catch {
      return '';
    }
  }, []);

  const onCancel = () => {
    enable(false);
    reset();
  };
  const navigateBackOnCancel = ({ navigateBack }) => () => {
    navigateBack();
  };

  const onCompleted = async (values) => {
    parentNavigateForward(values);
  };

  const onValuesChanged = (props) => {
    const { values, currentStep } = props;
    if (!values) return;

    const formData = values.formValues[values.childStep] || values.formValues;
    const isResponsibleStep = values.childStep === 'responsible' && formData;

    if (!isResponsibleStep) {
      return dispatch(
        changeStep({
          step: "basicInfo",
          currentStep,
          parentCurrentStep,
          [values.childStep]: formData,
        })
      );
    }

    const { gettingStarted, ...responsibleData } = formData;

    return dispatch(
      changeStep({
        step: "basicInfo",
        currentStep,
        parentCurrentStep,
        responsible: responsibleData,
        gettingStarted,
      })
    );

  };

  function onSubmit({ navigateForward, childStep }) {
    return (values) => {
      navigateForward({ childStep, formValues: values });
    };
  }

  const steps = [
    {
      content: (props) => (
        <Responsible
          {...props}
          initialValues={{
            responsible,
            gettingStarted: {
              document: documentFromStorage,
              seller_id: sellerIdFromStorage,
              ...responsible?.gettingStarted
            }
          }}
          onCancel={onCancel}
          onSubmit={onSubmit({ ...props, childStep: 'responsible' })}
        />
      ),
    },
    {
      content: (props) => (
        <ContactInfo
          {...props}
          initialValues={contactInfo}
          onCancel={navigateBackOnCancel(props)}
          onSubmit={onSubmit({ ...props, childStep: 'contactInfo' })}
        />
      ),
    },
    {
      content: (props) => (
        <Step {...props}>
          <TabContainer step={3} totalSteps={3}>
            <Address
              {...props}
              initialValues={{ address }}
              onCancel={navigateBackOnCancel(props)}
              onSubmit={onSubmit({ ...props, childStep: "address" })}
            />
          </TabContainer>
        </Step>
      ),
    },
  ];

  return withWizard({
    steps,
    cancel,
    theme,
    onCompleted,
    onValuesChanged,
    initialStep,
  })(({ children }) => <StepContentWrapper>{children}</StepContentWrapper>);
}
